import { motion } from "framer-motion";
import { ArrowLeft, ShieldCheck, FileText, Lock } from "lucide-react";
import { Link } from "react-router-dom";

export default function Legal() {
  return (
    <div className="min-h-screen bg-background px-6 py-8 pb-20">
      {/* Botão Voltar */}
      <Link to="/register" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-8">
        <ArrowLeft className="w-5 h-5" />
        <span className="font-medium">Voltar para o cadastro</span>
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="prose prose-sm dark:prose-invert max-w-none"
      >
        <h1 className="text-3xl font-bold mb-6">Documentos Legais</h1>

        {/* --- SEÇÃO: POLÍTICA DE PRIVACIDADE --- */}
        <section className="mb-12">
          <div className="flex items-center gap-2 mb-4 text-primary">
            <ShieldCheck className="w-6 h-6" />
            <h2 className="text-xl font-bold m-0 text-foreground">Política de Privacidade</h2>
          </div>
          
          <div className="space-y-4 text-muted-foreground leading-relaxed text-sm">
            <p><strong>1. Coleta de Dados:</strong> Coletamos seu nome, e-mail e idade para fins de autenticação e personalização da sua experiência no aplicativo.</p>
            
            <p><strong>2. Dados Financeiros:</strong> Todos os dados de receitas, despesas e planejamento inseridos são de sua inteira propriedade. Nós utilizamos criptografia para garantir que apenas você tenha acesso a esses registros.</p>
            
            <p><strong>3. Uso das Informações:</strong> Seus dados pessoais e financeiros <strong>jamais</strong> serão vendidos ou compartilhados com terceiros (bancos, corretoras ou anunciantes). O uso é estritamente para o funcionamento das ferramentas de gestão do app.</p>
            
            <p><strong>4. Segurança (LGPD):</strong> Em conformidade com a Lei Geral de Proteção de Dados, você tem o direito de solicitar a exportação ou exclusão definitiva de todos os seus dados a qualquer momento através das configurações do perfil.</p>
          </div>
        </section>

        {/* --- SEÇÃO: TERMOS DE USO --- */}
        <section>
          <div className="flex items-center gap-2 mb-4 text-primary">
            <FileText className="w-6 h-6" />
            <h2 className="text-xl font-bold m-0 text-foreground">Termos de Uso</h2>
          </div>

          <div className="space-y-4 text-muted-foreground leading-relaxed text-sm">
            <p><strong>1. Finalidade:</strong> Este aplicativo é uma ferramenta de auxílio à organização financeira pessoal. Ele não constitui, em hipótese alguma, consultoria financeira, jurídica ou de investimentos.</p>
            
            <p><strong>2. Responsabilidade:</strong> O usuário é o único responsável pela veracidade dos dados inseridos e pelas decisões financeiras tomadas com base nas informações visualizadas no app.</p>
            
            <p><strong>3. Limitação:</strong> Não nos responsabilizamos por perdas financeiras, diretas ou indiretas, decorrentes do uso da plataforma ou de eventuais períodos de indisponibilidade do sistema.</p>
            
            <p><strong>4. Idade Mínima:</strong> Ao utilizar este serviço, você declara ter idade legal para gerir suas próprias finanças ou possuir autorização dos responsáveis.</p>
          </div>
        </section>
      </motion.div>

      {/* Rodapé de Segurança */}
      <div className="mt-12 p-4 bg-secondary/30 rounded-xl flex items-center gap-3">
        <Lock className="w-5 h-5 text-primary" />
        <p className="text-[11px] text-muted-foreground leading-tight uppercase tracking-wider font-semibold">
          Segurança de nível bancário: seus dados financeiros são tratados com sigilo absoluto.
        </p>
      </div>
    </div>
  );
}